import React from 'react';
import FileInput from '../components/Inputs/file-input';

export default function DocumentUploadSection({
    title,
    formData,
    handleFileChange,
    documents,
    formErrors,
    compact = false
}) {
    const customerLast = formData?.customer?.lastname || '';
    const customerFirst = formData?.customer?.firstname || '';

    return (
        <div className={compact ? '' : 'mt-8'}>
            {/* Title hidden in compact mode */}
            {!compact && !!title && (
                <h2 className="text-lg font-bold mb-6 text-primary">{title}</h2>
            )}

            <div className="space-y-6">
                {documents.map((doc, idx) => {
                    // expecting doc = { name: 'doc_<id>', label, description, italicNote, downloadLink, downloadLabel }
                    const fieldName = String(doc.name || `doc_${idx}`);
                    const displayLabel = String(doc.label || 'Document');
                    const fileLabel = `${displayLabel}${customerLast || customerFirst ? ` - ${customerLast} ${customerFirst}` : ''}`.trim();

                    const value = formData?.[fieldName];
                    const error = formErrors?.[fieldName];

                    return (
                        <div key={fieldName} className="flex flex-col md:flex-row gap-6">
                            {/* Left: file input (same width rhythm as other forms) */}
                            <div className="w-full md:w-64">
                                <FileInput
                                    name={fieldName}
                                    label={fileLabel}
                                    onChange={handleFileChange}
                                    value={value}
                                    error={error}
                                />
                            </div>

                            {/* Right: text block */}
                            <div className="flex flex-col w-full">
                                {!!doc.label && (
                                    <p className="text-md text-primary font-semibold">{doc.label}</p>
                                )}
                                {!!doc.description && (
                                    <p className="text-sm text-gray-700 mt-1 whitespace-pre-line">{doc.description}</p>
                                )}
                                {!!doc.italicNote && (
                                    <p className="text-sm italic text-gray-700 mt-1">{doc.italicNote}</p>
                                )}
                                {!!doc.downloadLink && (
                                    <a
                                        href={doc.downloadLink}
                                        target="_blank"
                                        rel="noreferrer"
                                        className="text-primary underline text-sm mt-2"
                                    >
                                        {doc.downloadLabel || 'Télécharger le modèle'}
                                    </a>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}